import { styled } from 'stitches.config'
import {
  ProductCard as ProductCardProductCatalog,
  ProductImage as ProductImageProductCatalog,
  ProductsGrid as ProductsGridProductCatalog,
  ProductTitleWrapper as ProductTitleWrapperProductCatalog,
} from '../../../../AllProducts/components/ProductCatalog/ProductCatalog.styles'

export const PriceWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  marginBottom: '$1',
})

export const OriginalPrice = styled('span', {
  color: '$quaternary-200',
  textDecoration: 'line-through',
  fontSize: '$bodyLarge',
  textDecorationColor: '$primary-500',
})

export const DiscountedPrice = styled('span', {
  color: '$primary-500',
  fontSize: '$bodyLarge',
  fontWeight: '$medium',
})

export const ProductImage = styled(ProductImageProductCatalog, {
  '& img': {
    borderRadius: 0,
  },
  margin: 0,
  height: 'auto',
  marginBottom: '$3',
  width: '100%',

  '&.small-box': {
    maxWidth: '190px',
    marginBottom: '$5',
  },
  '&.classic-box': {
    maxWidth: '240px',
    marginBottom: '$3',
  },
  '&.big-box': {
    maxWidth: '290px',
    marginBottom: '$1',
  },

  '@bp3': {
    '&.small-box': {
      marginBottom: '$3',
      maxWidth: '300px',
    },
    '&.classic-box': {
      marginBottom: '$3',
      maxWidth: '370px',
    },
    '&.big-box': {
      marginBottom: '$3',
      maxWidth: '430px',
    },
  },
})

export const ProductsGrid = styled(ProductsGridProductCatalog, {
  flexWrap: 'wrap',
  marginBottom: '$4',
  '@bp3': {
    gap: '$3',
  },
  '@bp4': {
    flexWrap: 'nowrap',
  },
})

export const ProductCard = styled(ProductCardProductCatalog, {
  maxWidth: '328px',
  maxHeight: 'none',
  height: '382px',

  '@bp3': {
    maxWidth: '564px',
    height: '496px',
  },
})

export const HeaderWrapper = styled('div', {
  margin: 'auto',
  marginTop: '$6',
  marginBottom: '$3',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$2',
  width: '100%',
  maxWidth: '371px',

  '@bp3': {
    maxWidth: '700px',
  },
})

export const ProductTitleWrapper = styled(ProductTitleWrapperProductCatalog, {
  marginBottom: '$1',
})

export const CtaWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '100%',
})
